import { CloseCircleOutlined, LockOutlined, MailOutlined } from '@ant-design/icons'
import { Button, Card, Form, Image, Input, message } from 'antd'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { BE_HOST } from '../../config/config'
import Applogo from "../../assets/aapaNewlogoTm.png";
import { HandleOnclose, hashWithSalt } from '../../utils/hash'
import { useDispatch, useSelector } from 'react-redux'
import { USER_LOGIN_CLEAR_STATE, USER_TOKEN } from '../../redux/types'
import { persistor } from '../../redux/store'
import newLogo from '../../assets/advant-logoTm.png'


const ResetPassword = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams();
  const [form] = Form.useForm();
  const location = useLocation()
  const token = searchParams.get("token") || location.state?.token;
  const email = location.state?.email;
  const [isLoading, setIsLoading] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const dispatch = useDispatch()
const userToken = useSelector((state) => state.userAuth.token?.token);
  const handleResetPassword = async (value) => {

    if (hasSubmitted) return;
    setHasSubmitted(true);

    if (!token) {
      message.error("Reset token missing from URL");
      setHasSubmitted(false);
      return;
    }


    setIsLoading(true)
    const hashedPassword = hashWithSalt(value?.password)
    const hashedConfirmPassword = hashWithSalt(value?.Confirm_password)

    const payload = {
      token,
      newPassword: hashedPassword,
      confirmPassword: hashedConfirmPassword,
      url:window.location.origin
    };

    try {
      console.log(" Sending request...");
      const response = await axios.post(`${BE_HOST}/auth/reset-password`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          }
        }
      );
      console.log("Response:", response.data);
      message.success(response.data?.message)
      localStorage.removeItem("userInfo"); //token
      localStorage.removeItem("token"); //token
      
      persistor.purge();
      dispatch({
        type: USER_LOGIN_CLEAR_STATE,
      });
      dispatch({
        type: USER_TOKEN,
        payload: {
          token: '',
          decodedToken: '', // Parse the JSON string
        },
      })
      navigate('/Login', {
        state: { email: email }
      })
      localStorage.clear()
    } catch (error) {
      console.error(" Error:", error.response?.data || error.message);
      message.error(error?.response.data?.message)
      
      setHasSubmitted(false);
    } finally {
      setIsLoading(false)
      console.log(" Cleanup or loading state reset here");
    }
  }

  useEffect(() => {
    if (!token) {
      if (userToken) {
        navigate("/react-dashboard");
      } else {
        navigate("/login");
      }
    }
  }, [token, navigate]);

  return (
    <div className="min-h-screen bg-[#000833] flex flex-col items-center justify-start pt-20 p-4">
        {
        email && (
      <div style={{ alignSelf:"flex-end",  right: 20, cursor: 'pointer', }}  onClick={()=>HandleOnclose(dispatch)}>
         <CloseCircleOutlined style={{ fontSize: 24, color: 'white' }} />
       </div>

        )
      }
      <div className='mb-2'>

      <Image
        style={{marginTop:"6px"}}
          src={Applogo}
          alt="AAPA Logo"
          preview={false}
          className=" rounded-md"
          width={160}
          height={140}
          />
          </div>
    
      <div className="w-full max-w-[800px] flex flex-col items-center bg-[#000833] rounded-2xl border-[3px] border-white">
        <img
          src={newLogo}
          alt="AAPA Logo"
          style={{ marginTop: "28px", marginBottom: "28px" }}
          width={300}
          className="mb-8"
        />

        <Card className="w-full max-w-[400px] shadow-lg rounded-lg overflow-hidden bg-[#000833] text-center mb-10">
          <h2 className="text-2xl font-bold text-white mb-4 flex items-center justify-center gap-2">
            <LockOutlined style={{ fontSize: 26, color: "#0EA5E9" }} />
            Reset Password
          </h2>

          <Form
            form={form}
            onFinish={handleResetPassword}
            layout="vertical"
            className="mt-4"
          >
            <Form.Item
              name="password"
              rules={[
                { required: true, message: "Please enter your password" },
                {
                  validator: (_, value) => {
                    if (!value) return Promise.resolve();

                    if (value.length < 8) {
                      return Promise.reject("Password must be at least 8 characters");
                    }
                    if (!/[A-Z]/.test(value)) {
                      return Promise.reject("Password must include an uppercase letter");
                    }
                    if (!/\d/.test(value)) {
                      return Promise.reject("Password must include a number");
                    }
                    if (!/[^A-Za-z0-9]/.test(value)) {
                      return Promise.reject("Password must include a special character");
                    }
                    if (/(.)\1{2,}/.test(value)) {
                      return Promise.reject("Password must not contain 3+ repeated characters");
                    }

                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input.Password
                prefix={<LockOutlined className="text-gray-400" />}
                placeholder="Password"
                size="large"
                className="h-12"
              />
            </Form.Item>

            <Form.Item
              name="Confirm_password"
              dependencies={["password"]}
              rules={[
                { required: true, message: "Please enter Confirm password" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Passwords do not match"));
                  },
                }),
              ]}
            >
              <Input.Password
                prefix={<LockOutlined className="text-gray-400" />}
                placeholder="Confirm Password"
                size="large"
                className="h-12"
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                block
                size="large"
                loading={isLoading}
                className="h-12 bg-[#0EA5E9] hover:bg-[#0EA5E9]/90"
              >
                Reset Password
              </Button>
            </Form.Item>
          </Form>
        </Card>

      </div>
       <style>
        {`
          .ant-message .ant-message-notice {
            padding: 16px 24px;
          }

          .ant-message .ant-message-notice-content {
            font-size: 24px;
            min-height: 50px;
            display: flex;
            align-items: center;
          }
        `}
      </style>
    </div>
  );

}

export default ResetPassword
